// knest_theme.bundle.js — Verticals branding (favicon, logo, login footer, full-width)
// Adapted from the extrusion knest_theme JS, repointed to knest_aluform assets.
(() => {
  try { window.__knest_theme = "verticals-v1-2026-09-04"; } catch (e) {}

  // ✅ brand asset paths (files vendored in knest_aluform/public/images)
  const BRAND_LOGO = "/assets/knest_aluform/images/knest_ct_logo.png";
  const FAVICON = "/assets/knest_aluform/images/knest-favicon.png";
  const SUPPORT_EMAIL = "erp.support@knestaluform.in";

  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  function setImgSrc(el, src) {
    if (!el) return false;
    if ((el.getAttribute("src") || "") === src) return false;
    el.setAttribute("src", src);
    return true;
  }

  function setFavicon(url) {
    const isSvg = url.toLowerCase().endsWith(".svg");
    const type = isSvg ? "image/svg+xml" : "image/png";
    [{ rel: "icon", type }, { rel: "shortcut icon", type }, { rel: "apple-touch-icon" }].forEach(({ rel, type }) => {
      let link = document.querySelector(`link[rel="${rel}"]`);
      if (!link) { link = document.createElement("link"); link.rel = rel; document.head.appendChild(link); }
      if (type) link.type = type;
      link.href = url;
    });
  }

  // Full width ON by default (only when the user has never chosen).
  function ensureFullWidth() {
    try {
      if (localStorage.container_fullwidth == null) localStorage.container_fullwidth = "true";
      if (window.frappe?.ui?.toolbar?.set_fullwidth_if_enabled) { frappe.ui.toolbar.set_fullwidth_if_enabled(); return; }
    } catch (e) {}
    try {
      if (document.body && JSON.parse(localStorage.container_fullwidth || "false")) document.body.classList.add("full-width");
    } catch (e) {}
  }

  function applyBranding() {
    // 1) desk + login logo
    setImgSrc(document.getElementById("brand-logo"), BRAND_LOGO);
    $$("#brand-logo, .navbar-home img, .app-logo, img[alt='App Logo']").forEach((img) => setImgSrc(img, BRAND_LOGO));

    // 2) favicon
    setFavicon(FAVICON);

    // 2b) role flag on <body> so CSS can keep workspace edit controls for admins only
    try {
      const sm = (window.frappe?.user?.has_role && frappe.user.has_role("System Manager")) ||
        window.frappe?.session?.user === "Administrator";
      document.body.classList.toggle("knest-sysmgr", !!sm);
    } catch (e) {}

    // 3) login heading text
    const LOGIN_TITLE = "Login to VERTICALS ERP";
    const loginHeading = document.querySelector(".for-login .page-card-head h4");
    if (loginHeading && loginHeading.textContent.trim() !== LOGIN_TITLE) {
      loginHeading.textContent = LOGIN_TITLE;
    }

    // 4) login-only chrome: support line + credit footer (matches extrusion)
    const loginCard = document.querySelector(".for-login .login-content.page-card");
    if (loginCard && !loginCard.querySelector(".knest-login-support")) {
      const support = document.createElement("div");
      support.className = "knest-login-support";
      support.innerHTML = 'For support, mail to: <a href="mailto:' + SUPPORT_EMAIL + '">' + SUPPORT_EMAIL + "</a>";
      loginCard.appendChild(support);
    }
    const loginStrip = document.querySelector(".for-login");
    if (loginStrip && !loginStrip.querySelector(".knest-footer-credit")) {
      const credit = document.createElement("div");
      credit.className = "knest-footer-credit";
      credit.innerHTML =
        '<div class="knest-credit">© 2026 · Designed &amp; Developed by <b>Knest R&amp;D Team</b></div>' +
        '<div class="knest-powered">Powered by Frappe Framework</div>';
      loginStrip.appendChild(credit);
    }

    // 4) navbar Help menu: hide "Frappe Support"; "About" only for System Managers
    const helpMenu = document.querySelector("#toolbar-help");
    if (helpMenu) {
      let isSysMgr = false;
      try {
        isSysMgr = (window.frappe?.user?.has_role && frappe.user.has_role("System Manager")) ||
          window.frappe?.session?.user === "Administrator";
      } catch (e) {}
      helpMenu.querySelectorAll(".dropdown-item").forEach((el) => {
        const t = (el.textContent || "").trim().toLowerCase();
        if (t === "frappe support") el.style.display = "none";
        if (t === "about") el.style.display = isSysMgr ? "" : "none";
      });
    }

    // 5) full width
    ensureFullWidth();
  }

  let scheduled = false;
  function scheduleApply() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; applyBranding(); });
  }

  scheduleApply();
  document.addEventListener("DOMContentLoaded", () => {
    scheduleApply();
    let n = 0;
    const t = setInterval(() => { scheduleApply(); if (++n >= 10) clearInterval(t); }, 400);
  });
  if (window.frappe?.router?.on) frappe.router.on("change", scheduleApply);
  if (window.frappe?.after_ajax) frappe.after_ajax(scheduleApply);
  const startObserver = () => {
    if (!document.body) return setTimeout(startObserver, 50);
    new MutationObserver(scheduleApply).observe(document.body, { childList: true, subtree: true });
  };
  startObserver();
})();
